/* MIRIJANA — spiritual scroll reveal, site-wide.
   Gentle opacity + soft-blur focus-in as content enters the viewport.
   Transform-free (won't clash with Beae's scroll script or the homepage
   transform-block). Fail-safe: the hidden state is only ever applied by JS,
   so if anything breaks, content simply shows normally — never stuck hidden. */
(function () {
  try {
    // header darkens/warms on scroll (runs regardless of reduced-motion)
    var onScroll = function () {
      document.documentElement.classList.toggle('mj-scrolled', (window.scrollY || window.pageYOffset || 0) > 60);
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (!('IntersectionObserver' in window)) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var SELECTOR = [
      'main h1', 'main h2', 'main h3',
      'main .h0', 'main .h1', 'main .h2',
      'main .card', 'main .card-wrapper', 'main .collection-list__item',
      'main .grid__item', 'main .media', 'main .product-media-container',
      'main .banner__box', 'main .rich-text__blocks', 'main blockquote',
      'main .product__info-container', 'main figure', 'main .quote', 'main .band'
    ].join(',');

    function reveal(el) { el.classList.add('mj-on'); }

    function run() {
      var root = document.querySelector('main') || document.body;
      if (!root) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

      var n = 0;
      root.querySelectorAll(SELECTOR).forEach(function (el) {
        if (el.classList.contains('rv') || el.classList.contains('mj-rise')) return; // homepage hero handles itself
        if (el.closest('.mj-rise')) return; // avoid nested double-reveal
        // Sections that animate as complete units (or via their own scripts) are
        // off limits: animating a heading separately from its own paragraph put
        // the two on top of each other mid-flight — the mobile overlap bug.
        if (el.closest('.rv,.mjhero,.mjfeat,.mjcat,.mjprod,.mjlead,.mjquote,.coaching-container,.heart-section,.mirijana-section,.product__info-wrapper,.product__info-container')) return;
        el.classList.add('mj-rise');
        el.style.transitionDelay = ((n % 3) * 90) + 'ms';
        io.observe(el);
        n++;
        // if it's already on-screen at load, reveal on next frame
        var r = el.getBoundingClientRect();
        if (r.top < (innerHeight || document.documentElement.clientHeight)) {
          requestAnimationFrame(function () { requestAnimationFrame(function () { reveal(el); }); });
        }
      });

      // ultimate safety net: nothing may stay invisible for more than 3s
      setTimeout(function () {
        document.querySelectorAll('.mj-rise:not(.mj-on)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < (innerHeight || 0) * 1.2) reveal(el);
        });
      }, 3000);
    }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
  } catch (e) { /* never break the page for an animation */ }
})();

/* Product photos stay the same size. srcset was handing the browser a small
   copy, which looks soft. Always use the original file. */
(function () {
  function sharpenCovers() {
    var nodes = document.querySelectorAll('.product__media-wrapper img, .card__media img, .heart-image img, .mirijana-image img, img[src*="1600x2000"], img[src*="SLH_1_Cover"]');
    for (var i = 0; i < nodes.length; i++) {
      var img = nodes[i];
      var src = img.currentSrc || img.getAttribute('src') || '';
      if (!/([?&])width=\d+/.test(src)) continue;
      img.removeAttribute('srcset');
      img.sizes = '';
      var target = /1600x2000|SLH_1_Cover/.test(src) ? 2000 : 2400;
      if (parseInt((src.match(/[?&]width=(\d+)/) || [])[1], 10) >= target) continue;
      img.src = src.replace(/([?&])width=\d+/, '$1width=' + target);
    }
  }
  if (document.readyState !== 'loading') sharpenCovers();
  else document.addEventListener('DOMContentLoaded', sharpenCovers);
  window.addEventListener('load', sharpenCovers);
})();
